import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import {
  Trash2,
  Pencil,
  Clock,
  User,
  Calendar,
  Star,
  Download,
  Save,
  Send,
  ArrowLeft,
  ChevronLeft,
  ChevronRight,
  Sun,
  Moon,
  FileText,
  DollarSign,
  Gift,
  MessageSquare,
  CheckCircle2,
  AlertCircle,
  Settings,
  Eye,
  Edit3,
  Plus,
  Minus
} from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { Badge } from "../../components/reusableComponents/Badge";
import { Card, CardContent } from "../../ui/Card";
import releveHeuresService from "../../services/releveHeuresService";
import { toast } from "react-toastify";




// Données mock pour simuler un relevé d'heures
const mockTimeSheet= {
  id: "TS-20241209",
  weekNumber: 3,
  year: 2024,
  startDate: "09/12/2024",
  endDate: "15/12/2024",
  employeeName: "KUMBA MHRIA",
  employeePosition: "MANUTENTIONNAIRE",
  employeeCompany: "LES GARTRES",
  employeeId: "1412_5",
  hours: {
    "lundi": "7.5",
    "mardi": "7.5",
    "mercredi": "7.5",
    "jeudi": "7.5",
    "vendredi": "7.5",
    "samedi": "",
    "dimanche": ""
  },
  nightHours: {
    "lundi": "",
    "mardi": "2",
    "mercredi": "",
    "jeudi": "",
    "vendredi": "",
    "samedi": "",
    "dimanche": ""
  },
  absences: {
    "lundi": "",
    "mardi": "",
    "mercredi": "",
    "jeudi": "",
    "vendredi": "",
    "samedi": "",
    "dimanche": ""
  },
  status: "pending",
  clientComment: "",
  employeeComment: "",
  projectNumber: "CH-2024-103",
  endOfMission: false,
  clientRating: 0,
  clientRatingComment: ""
};
const mockTimeSheets = [mockTimeSheet];
// Jours de la semaine avec leurs dates pour la semaine courante
const weekDays = [
  { name: "Lundi", date: "13/01", key: "lundi" },
  { name: "Mardi", date: "14/01", key: "mardi" },
  { name: "Mercredi", date: "15/01", key: "mercredi" },
  { name: "Jeudi", date: "16/01", key: "jeudi" },
  { name: "Vendredi", date: "17/01", key: "vendredi" },
  { name: "Samedi", date: "18/01", key: "samedi" },
  { name: "Dimanche", date: "19/01", key: "dimanche" }
];

const heures = [
    "Heures diverses", "Heures d'entretien annuel","Heures de formation", "Heures de pause", "Heures de réunion" ,"Heures de route", "Heures visite médicale"
  ];

const primes = [
    "Prime 13e mois", "Prime d’assiduité", "Prime d’ancienneté", "Prime d’astreinte",
    "Prime d’encadrement", "Prime de fonction", "Prime de salissure", "Prime de pénibilité", "Prime de performance",
    "Prime de productivité", "Prime de remplacement", "Prime de responsabilité", "Prime de rendement", "Prime de caissier(e)",
    "Prime de déménagement", "Prime de fin d’année", "Prime de froid", "Prime de jours fériés", "Prime de mariage",
    "Prime de maîtrise", "Prime de nuit", "Prime de panier", "Prime de ponctualité", "Prime de prestation",
    "Prime de résultats", "Prime de secrétariat", "Prime de sujétion", "Prime de vacances", "Prime exceptionnelle",
    "Prime Macron / PPV", "Prime de non-concurrence", "Prime de départ en retraite", "Prime de polyvalence", "Prime de danger"
  ];

const indemnites = [
    "Indemnité de déplacement", "Indemnité de départ volontaire", "Indemnité de formation",
    "Indemnité de fonction", "Indemnité de logement", "Indemnité de non-concurrence", "Indemnité de sujétion",
    "Indemnité de trajet", "Indemnité de transport", "Indemnité de repas", "Indemnité de panier", "Indemnité kilométrique"
  ];

const heureOptions = heures.map((heure) => ({
  value: heure.toLowerCase().replace(/\s+/g, '_'),
  label: heure,
}))

const primeOptions = primes.map((prime) => ({
  value: prime.toLowerCase().replace(/\s+/g, '_'),
  label: prime,
}))

const indemniteOptions = indemnites.map((indemnite) => ({
  value: indemnite.toLowerCase().replace(/\s+/g, '_'),
  label: indemnite,
}))
const RelevesHeures = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [timeSheet, setTimeSheet] = useState(mockTimeSheet);
  const [hourFormat, setHourFormat] = useState("minutes");
  const [nightHoursOption, setNightHoursOption] = useState("included"); // Inclus dans les heures de jour ou additionnel
  const [weekHoursOption, setweekHoursOption] = useState("35h");
  const [clientComment, setClientComment] = useState("");
  const [employeeComment, setEmployeeComment] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [clientRating, setClientRating] = useState(0);
  const [clientRatingComment, setClientRatingComment] = useState("");
  const [primes, setPrimes] = useState([]);
  const [indemnites, setIndemnites] = useState([]);
  const [heures, setHeures] = useState([]);
  const [selectedPrime, setSelectedPrime] = useState(null);
  const [quantitePrime, setQuantitePrime] = useState('');
  const [montantPrime, setMontantPrime] = useState('');
  const [selectedIndemnite, setSelectedIndemnite] = useState(null);
  const [quantiteIndemnite, setQuantiteIndemnite] = useState('');
  const [montantIndemnite, setMontantIndemnite] = useState('');
  const [editingPrimeId, setEditingPrimeId] = useState(null);
  const [editingIndemniteId, setEditingIndemniteId] = useState(null);
  const [selectedHeure, setSelectedHeure] = useState(null);
  const [quantiteHeure, setQuantiteHeure] = useState('');
  const [editingHeureId, setEditingHeureId] = useState(null);
  const [isPdfExporting, setIsPdfExporting] = useState(false);
  const [isLocked, setIsLocked] = useState(false); // verrouillage après enregistrement
  const [modificationRequested, setModificationRequested] = useState(false); // demande en attente
  const [modificationApproved, setModificationApproved] = useState(false); // validé par l'agence (via API plus tard)
  const [motifAbsences, setMotifAbsences] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [releveHeureId, setReleveHeureId] = useState(null);




  const handleSave = async () => {
    if (!validerAvantEnregistrement()) {
      return;
    }

    setIsSaving(true);
    try {
      const releveData = {
        ...timeSheet,
        heures,
        primes: [...primes, ...indemnites], // Combiner primes et indemnités
        clientComment,
        employeeComment,
        clientRating,
        clientRatingComment
      };

      if (releveHeureId) {
        // Mise à jour d'un relevé existant
        await releveHeuresService.updateReleveHeure(releveHeureId, releveData);
        toast.success("Relevé d'heures mis à jour avec succès !");
      } else {
        // Création d'un nouveau relevé (pour l'instant, on garde la logique existante)
        toast.success("Relevé d'heures sauvegardé localement !");
      }

      setIsLocked(true);
    } catch (error) {
      console.error('Erreur lors de la sauvegarde:', error);
      toast.error('Erreur lors de la sauvegarde du relevé d\'heures');
    } finally {
      setIsSaving(false);
    }
  };

  const handleModificationRequest = () => {
    // TODO: Implémenter l'appel API pour demander une modification
    setModificationRequested(true);
    toast.info("Votre demande de modification a été envoyée. Veuillez attendre la validation de l'agence.");
  };

  // Exemple à appeler quand tu reçois une réponse positive
  const approveModification = () => {
    setModificationApproved(true);
    setIsLocked(false); // On débloque les champs
  };


  const handleAddHeure = () => {
  if (selectedHeure && quantiteHeure) {
    setHeures(prev => [
      ...prev,
      {
        id: Date.now() + Math.random(),
        type: selectedHeure.label,
        quantite: parseFloat(quantiteHeure),
      }
    ]);
    setSelectedPrime(null);
    setQuantiteHeure('');
  }
};
  
  const handleAddPrime = () => {
  if (selectedPrime && montantPrime && quantitePrime) {
    setPrimes(prev => [
      ...prev,
      {
        id: Date.now() + Math.random(),
        type: selectedPrime.label,
        montant: parseFloat(montantPrime),
        quantite: parseFloat(quantitePrime),
      }
    ]);
    setSelectedPrime(null);
    setMontantPrime('');
    setQuantitePrime('');
  }
};


const handleAddIndemnite = () => {
  if (selectedIndemnite && montantIndemnite && quantiteIndemnite) {
    setIndemnites(prev => [
      ...prev,
      {
        id: Date.now() + Math.random(),
        type: selectedIndemnite.label,
        montant: parseFloat(montantIndemnite),
        quantite: parseFloat(quantiteIndemnite),
      }
    ]);
    setSelectedIndemnite(null);
    setMontantIndemnite('');
    setQuantiteIndemnite('');
  }
};

const handleDeleteHeure = (id) => {
  setHeures(prev => prev.filter(p => p.id !== id));
};

const handleDeletePrime = (id) => {
  setPrimes(prev => prev.filter(p => p.id !== id));
};

const handleDeleteIndemnite = (id) => {
  setIndemnites(prev => prev.filter(i => i.id !== id));
};

const handleUpdateHeure = () => {
  const updatedRows = heures.map(row =>
    row.id === editingHeureId
      ? {
          ...row,
          type: selectedHeure.label,
          quantite: parseFloat(quantiteHeure)
        }
      : row
  );
  setHeures(updatedRows);
  setEditingHeureId(null);
  setSelectedHeure(null);
  setQuantiteHeure('');
};

const handleUpdatePrime = () => {
  const updatedRows = primes.map(row =>
    row.id === editingPrimeId
      ? {
          ...row,
          type: selectedPrime.label,
          montant: parseFloat(montantPrime),
          quantite: parseFloat(quantitePrime)
        }
      : row
  );
  setPrimes(updatedRows);
  setEditingPrimeId(null);
  setSelectedPrime(null);
  setMontantPrime('');
  setQuantitePrime('');
};

const handleUpdateIndemnite = () => {
  const updatedRows = indemnites.map(row =>
    row.id === editingIndemniteId
      ? {
          ...row,
          type: selectedIndemnite.label,
          montant: parseFloat(montantIndemnite),
          quantite: parseFloat(quantiteIndemnite)
        }
      : row
  );
  setIndemnites(updatedRows);
  setEditingIndemniteId(null);
  setSelectedIndemnite(null);
  setMontantIndemnite('');
  setQuantiteIndemnite('');
};

const startEditHeure = (row) => {
  setEditingHeureId(row.id);
  setSelectedHeure({ label: row.type });
  setQuantiteHeure(row.quantite); 
};


const startEditPrime = (row) => {
  setEditingPrimeId(row.id);
  setSelectedPrime({ label: row.type });
  setMontantPrime(row.montant);
  setQuantitePrime(row.quantite); 
};

const startEditIndemnite = (row) => {
  setEditingIndemniteId(row.id);
  setSelectedIndemnite({ label: row.type });
  setMontantIndemnite(row.montant);
  setQuantiteIndemnite(row.quantite);
};




  // Charger les motifs d'absence au démarrage
  useEffect(() => {
    loadMotifAbsences();
  }, []);

  // Récupérer l'ID du relevé d'heures depuis l'URL et charger les données
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const timesheetId = searchParams.get('id');

    if (timesheetId) {
      setReleveHeureId(timesheetId);
      loadReleveHeureData(timesheetId);
    }
  }, [location.search]);

  // Charger les motifs d'absence depuis l'API
  const loadMotifAbsences = async () => {
    try {
      const motifs = await releveHeuresService.getMotifAbsence();
      setMotifAbsences(motifs);
    } catch (error) {
      console.error('Erreur lors du chargement des motifs d\'absence:', error);
      toast.error('Erreur lors du chargement des motifs d\'absence');
    }
  };

  // Charger les données d'un relevé d'heures spécifique
  const loadReleveHeureData = async (id) => {
    setIsLoading(true);
    try {
      // Pour l'instant, on utilise les données mockées
      // Dans le futur, on pourra ajouter une méthode getReleveHeureById au service
      console.log(`Chargement du relevé d'heures avec l'ID: ${id}`);

      // Simulation du chargement
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    } catch (error) {
      console.error('Erreur lors du chargement du relevé d\'heures:', error);
      toast.error('Erreur lors du chargement du relevé d\'heures');
      setIsLoading(false);
    }
  };

  // Fonction pour mettre à jour les heures
  const updateHours = (day, value) => {
    setTimeSheet(prev => ({
      ...prev,
      hours: {
        ...prev.hours,
        [day]: value
      }
    }));
  };
  
  // Fonction pour mettre à jour les heures de nuit
  const updateNightHours = (day, value) => {
    setTimeSheet(prev => ({
      ...prev,
      nightHours: {
        ...prev.nightHours,
        [day]: value
      }
    }));
  };
  
  // Fonction pour mettre à jour les motifs d'absence
  const updateAbsence = (day, value) => {
    setTimeSheet(prev => ({
      ...prev,
      absences: {
        ...prev.absences,
        [day]: value
      }
    }));
  };
  
  // Fonction pour calculer le total des heures
  const calculateTotalHours = () => {
    let total = 0;
    
    // Somme des heures de jour
    Object.values(timeSheet.hours).forEach(hours => {
      if (hours) {
        total += parseFloat(hours);
      }
    });
    
    // Ajout des heures de nuit si nécessaire
    if (nightHoursOption === "additional") {
      Object.values(timeSheet.nightHours).forEach(hours => {
        if (hours) {
          total += parseFloat(hours);
        }
      });
    }
    
    return total;
  };
  
  // Calcul des heures supplémentaires (au-delà de l'horaire sélectionné)
const calculateOvertimeHours = () => {
  const total = calculateTotalHours();

  // Extraire le nombre d'heures depuis le string "31h", "33h", etc.
  const baseHours = parseInt(weekHoursOption?.replace("h", "")) || 35;

  return total > baseHours ? total - baseHours : 0;
};

  // Formatage des heures selon le mode sélectionné
  const formatHours = (hours) => {
  if (!hours) return "";

  const hoursValue = parseFloat(hours);
  if (isNaN(hoursValue)) return "";

  if (hourFormat === "centiemes") {
    return hoursValue.toFixed(2).replace(".", ",");
  } else if (hourFormat === "minutes") {
    const hoursInt = Math.floor(hoursValue);
    const minutesDecimal = (hoursValue - hoursInt) * 60;
    const minutes = Math.round(minutesDecimal);
    return `${hoursInt}:${minutes.toString().padStart(2, '0')}`;
  } else {
    return hoursValue.toString();
  }
};


  // Fonction pour naviguer entre les semaines
  const navigateWeek = (direction) => {
    // Logique de navigation entre les semaines (dans un cas réel, il faudrait charger les données de la nouvelle semaine)
    setTimeSheet(prev => ({
      ...prev,
      weekNumber: direction === "prev" ? prev.weekNumber - 1 : prev.weekNumber + 1
    }));
    
    // Simulation du chargement
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  };

  // Fonction pour soumettre le relevé d'heures - Envoyer vers Tempo
  const submitTimeSheet = async () => {
    if (!validerAvantEnregistrement()) {
      return;
    }

    setIsSubmitting(true);
    try {
      const releveData = {
        ...timeSheet,
        heures,
        primes: [...primes, ...indemnites],
        clientComment,
        employeeComment,
        clientRating,
        clientRatingComment
      };

      // Transformer les données au format backend
      const backendData = releveHeuresService.transformToBackendFormat(releveData);

      // Envoyer vers Tempo via l'API
      await releveHeuresService.createReleveHeure(backendData);

      setTimeSheet(prev => ({
        ...prev,
        status: "integrated"
      }));

      toast.success("Relevé d'heures envoyé vers Tempo avec succès !");
    } catch (error) {
      console.error('Erreur lors de l\'envoi vers Tempo:', error);
      toast.error('Erreur lors de l\'envoi vers Tempo');
    } finally {
      setIsSubmitting(false);
    }
  };

  // Fonction pour envoyer vers l'agence
  const sendToAgency = async () => {
    if (!validerAvantEnregistrement()) {
      return;
    }

    try {
      // Pour l'instant, on simule l'envoi vers l'agence
      setTimeSheet(prev => ({
        ...prev,
        status: "to_integrate"
      }));

      toast.success("Relevé d'heures envoyé vers l'agence !");
    } catch (error) {
      console.error('Erreur lors de l\'envoi vers l\'agence:', error);
      toast.error('Erreur lors de l\'envoi vers l\'agence');
    }
  };

  // Fonction pour annuler le contrat
  const cancelContract = () => {
    setTimeSheet(prev => ({
      ...prev,
      status: "canceled",
    }));
    toast.info("Contrat annulé");
  };

  // Fonction pour télécharger le relevé
  const downloadTimeSheet = () => {
  setIsPdfExporting(true);

  setTimeout(() => {
  const input = document.getElementById("pdf-content");
  const Name = timeSheet.employeeName.trim() || "releve";
    
  html2canvas(input, { scale: 2 }).then((canvas) => {
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 20;

    const title = `Relevé d'heures de ${Name}`;
    pdf.setFont("helvetica", "bold"); // police en gras
    pdf.setFontSize(16);

    const textWidth = pdf.getTextWidth(title);
    const xCentered = (pageWidth - textWidth) / 2;

    pdf.text(title, xCentered, 15);

    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= (pageHeight - position);

    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    const safeName = Name.replace(/\s+/g, "_"); // remplace les espaces par des underscores
    const fileName = `releve_heures_${safeName}.pdf`;
    console.log("Nom du fichier sécurisé :", fileName);
    pdf.save(fileName);
    setIsPdfExporting(false); // on repasse en mode normal
  });
}, 100); 
  };
  
  // Fonction pour obtenir le libellé du statut en français
  const getStatusLabel = (status) => {
    switch(status) {
      case "pending":
        return "En attente";
      case "approved":
        return "Approuvé";
      case "rejected":
        return "Rejeté";
      case "canceled":
        return "Annulé";
      case "to_integrate":
        return "À intégrer";
      case "integrated":
        return "Intégré";
      default:
        return "Inconnu";
    }
  };
  
  // Fonction pour obtenir la classe CSS selon le statut
  const getStatusClass = (status)=> {
    switch(status) {
      case "pending":
        return "bg-yellow-100 text-yellow-800";
      case "approved":
        return "bg-green-100 text-green-800";
      case "rejected":
        return "bg-red-100 text-red-800";
      case "canceled":
        return "bg-red-100 text-red-800";
      case "to_integrate":
        return "bg-blue-100 text-blue-800";
      case "integrated":
        return "bg-purple-100 text-purple-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  const handleHourChange = (dayKey, value) => {
    setTimeSheet(prev => ({
      ...prev,
      hours: {
        ...prev.hours,
        [dayKey]: value
      }
    }));
  };

  const handleNightHourChange = (dayKey, value) => {
    setTimeSheet(prev => ({
      ...prev,
      nightHours: {
        ...prev.nightHours,
        [dayKey]: value
      }
    }));
  };


  const validerAvantEnregistrement = () => {
  const totalHeures = calculateTotalHours();

  // Conversion de weekHoursOption "35h" en nombre 35
  const modulationSemaine = parseInt(weekHoursOption);

  // Vérifie qu'au moins une heure est renseignée
  const heuresValides = totalHeures > 0;

  // Absences obligatoires si totalHeures < modulationSemaine
  let absencesRenseignees = true;
  if (totalHeures < modulationSemaine) {
    absencesRenseignees = Object.values(timeSheet.absences).some((val) => val && val.trim() !== "");
  }
  // Vérifie que "Fin de mission" est défini (true ou false)
  const finDeMissionRenseignee = typeof timeSheet.endOfMission === "boolean";

  // Si évaluation < 3, le commentaire devient obligatoire
  const commentaireObligatoire = clientRating >= 3 || (clientRating < 3 && clientRatingComment.trim() !== "");

  if (!heuresValides) {
    alert("Veuillez renseigner au moins une heure dans la semaine.");
    return false;
  }

  if (totalHeures < modulationSemaine && !absencesRenseignees) {
    alert("Veuillez renseigner au moins un motif d'absence pour compenser les heures manquantes.");
    return false;
  }


   if (!finDeMissionRenseignee) {
    alert("Veuillez indiquer si c'est la fin de mission.");
    return false;
  }

  if (!commentaireObligatoire) {
    alert("Veuillez ajouter un commentaire si la note est inférieure à 3 étoiles.");
    return false;
  }

  return true;
};


  return (
    <div className="w-full min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="w-full p-8">
        {/* Header Section */}
        <motion.div
          className="mb-8"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <motion.button
                onClick={() => navigate("/relevesdheures")}
                className="p-3 bg-white rounded-xl shadow-sm border border-slate-200 hover:bg-slate-50 transition-colors duration-200 flex items-center space-x-2"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <ArrowLeft className="w-5 h-5 text-slate-600" />
                <span className="text-sm font-medium text-slate-700">Retour à la liste</span>
              </motion.button>

              <div className="flex items-center space-x-3">
                <div className="p-3 bg-blue-100 rounded-xl">
                  <Clock className="w-8 h-8 text-blue-600" />
                </div>
                <div>
                  <h1 className="text-4xl font-bold text-slate-900">
                    Relevé d'Heures
                  </h1>
                  <p className="text-lg text-slate-600">
                    Semaine {timeSheet.weekNumber} • {timeSheet.startDate} - {timeSheet.endDate}
                  </p>
                </div>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              {/* Statut Badge */}
              <motion.div
                className={`px-4 py-2 rounded-lg font-medium border ${
                  timeSheet.status === 'pending' ? 'bg-amber-50 text-amber-700 border-amber-200' :
                  timeSheet.status === 'integrated' ? 'bg-emerald-50 text-emerald-700 border-emerald-200' :
                  'bg-slate-50 text-slate-700 border-slate-200'
                }`}
                whileHover={{ scale: 1.02 }}
              >
                {getStatusLabel(timeSheet.status)}
              </motion.div>

              {/* Navigation semaine */}
              <div className="flex items-center space-x-2 bg-white rounded-xl shadow-sm border border-slate-200 p-2">
                <motion.button
                  onClick={() => navigateWeek("prev")}
                  className="p-2 rounded-lg hover:bg-slate-100 transition-colors duration-200"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <ChevronLeft className="w-5 h-5 text-slate-600" />
                </motion.button>

                <div className="px-4 py-1">
                  <span className="text-sm font-medium text-slate-900">Semaine {timeSheet.weekNumber}</span>
                </div>

                <motion.button
                  onClick={() => navigateWeek("next")}
                  className="p-2 rounded-lg hover:bg-slate-100 transition-colors duration-200"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <ChevronRight className="w-5 h-5 text-slate-600" />
                </motion.button>
              </div>
            </div>
          </div>
        </motion.div>

        {isLoading ? (
          <motion.div
            className="flex justify-center items-center h-64"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
          </motion.div>
        ) : (
          <div id="pdf-content">
            {/* Informations Employé */}
            <motion.div
              className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 mb-8"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <div className="flex items-center space-x-6">
                <div className="flex-shrink-0">
                  <div className="h-16 w-16 rounded-full bg-gradient-to-r from-blue-400 to-blue-600 flex items-center justify-center">
                    <span className="text-xl font-bold text-white">
                      {timeSheet.employeeName.split(' ').map(n => n[0]).join('').substring(0, 2)}
                    </span>
                  </div>
                </div>
                <div className="flex-1">
                  <h2 className="text-2xl font-bold text-slate-900">{timeSheet.employeeName}</h2>
                  <p className="text-lg font-medium text-slate-600">{timeSheet.employeePosition}</p>
                  <div className="flex items-center space-x-4 mt-2">
                    <span className="text-sm text-slate-500">{timeSheet.employeeCompany}</span>
                    <span className="text-sm text-slate-400">•</span>
                    <span className="text-sm text-slate-500">ID: {timeSheet.employeeId}</span>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="text-right">
                    <p className="text-sm text-slate-500">Total semaine</p>
                    <p className="text-3xl font-bold text-slate-900">{calculateTotalHours().toFixed(1)}h</p>
                    {calculateOvertimeHours() > 0 && (
                      <p className="text-sm text-blue-600">+{calculateOvertimeHours().toFixed(1)}h sup.</p>
                    )}
                  </div>
                </div>
              </div>
            </motion.div>
            {/* Configuration et Options */}
            <motion.div
              className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              {/* Fin de Mission */}
              <motion.div
                className="bg-white rounded-xl shadow-sm border border-slate-200 p-6"
                whileHover={{ y: -2 }}
              >
                <div className="flex items-center space-x-3 mb-4">
                  <div className="p-2 bg-amber-100 rounded-lg">
                    <CheckCircle2 className="w-5 h-5 text-amber-600" />
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-slate-700">Fin de mission</h3>
                    <p className="text-xs text-slate-500">Statut de la mission</p>
                  </div>
                </div>
                {isPdfExporting ? (
                  <p className="text-lg font-semibold text-slate-900">
                    {timeSheet.endOfMission ? "Oui" : "Non"}
                  </p>
                ) : (
                  <select
                    value={timeSheet.endOfMission ? "oui" : "non"}
                    disabled={isLocked && !modificationApproved}
                    onChange={(e) =>
                      setTimeSheet((prev) => ({
                        ...prev,
                        endOfMission: e.target.value === "oui",
                      }))
                    }
                    className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  >
                    <option value="non">Non</option>
                    <option value="oui">Oui</option>
                  </select>
                )}
              </motion.div>

              {/* Chantier/Service */}
              <motion.div
                className="bg-white rounded-xl shadow-sm border border-slate-200 p-6"
                whileHover={{ y: -2 }}
              >
                <div className="flex items-center space-x-3 mb-4">
                  <div className="p-2 bg-green-100 rounded-lg">
                    <FileText className="w-5 h-5 text-green-600" />
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-slate-700">Chantier / Service</h3>
                    <p className="text-xs text-slate-500">Numéro de référence</p>
                  </div>
                </div>
                {isPdfExporting ? (
                  <p className="text-lg font-semibold text-slate-900">{timeSheet.projectNumber}</p>
                ) : (
                  <input
                    type="text"
                    disabled={isLocked && !modificationApproved}
                    value={timeSheet.projectNumber || ""}
                    onChange={(e) => setTimeSheet(prev => ({ ...prev, projectNumber: e.target.value }))}
                    className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="N° chantier ou service"
                  />
                )}
              </motion.div>

              {/* Format d'heures */}
              <motion.div
                className="bg-white rounded-xl shadow-sm border border-slate-200 p-6"
                whileHover={{ y: -2 }}
              >
                <div className="flex items-center space-x-3 mb-4">
                  <div className="p-2 bg-blue-100 rounded-lg">
                    <Settings className="w-5 h-5 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-slate-700">Format d'heures</h3>
                    <p className="text-xs text-slate-500">Mode d'affichage</p>
                  </div>
                </div>
                {isPdfExporting ? (
                  <p className="text-lg font-semibold text-slate-900">
                    {hourFormat === "centiemes" ? "Centièmes" : "Minutes"}
                  </p>
                ) : (
                  <div className="flex gap-2">
                    <motion.button
                      onClick={() => setHourFormat("minutes")}
                      className={`flex-1 px-3 py-2 text-sm rounded-lg font-medium transition-colors duration-200 ${
                        hourFormat === "minutes"
                          ? 'bg-blue-100 border border-blue-500 text-blue-700'
                          : 'border border-slate-200 text-slate-700 hover:bg-slate-50'
                      }`}
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                    >
                      Minutes
                    </motion.button>
                    <motion.button
                      onClick={() => setHourFormat("centiemes")}
                      className={`flex-1 px-3 py-2 text-sm rounded-lg font-medium transition-colors duration-200 ${
                        hourFormat === "centiemes"
                          ? 'bg-blue-100 border border-blue-500 text-blue-700'
                          : 'border border-slate-200 text-slate-700 hover:bg-slate-50'
                      }`}
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                    >
                      Centièmes
                    </motion.button>
                  </div>
                )}
              </motion.div>

              {/* Modulation semaine */}
              <motion.div
                className="bg-white rounded-xl shadow-sm border border-slate-200 p-6"
                whileHover={{ y: -2 }}
              >
                <div className="flex items-center space-x-3 mb-4">
                  <div className="p-2 bg-purple-100 rounded-lg">
                    <Calendar className="w-5 h-5 text-purple-600" />
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-slate-700">Modulation semaine</h3>
                    <p className="text-xs text-slate-500">Heures de base</p>
                  </div>
                </div>
                {isPdfExporting ? (
                  <p className="text-lg font-semibold text-slate-900">{weekHoursOption}</p>
                ) : (
                  <div className="grid grid-cols-3 gap-1">
                    {["31h", "33h", "35h", "37h", "39h"].map((hour) => (
                      <motion.button
                        key={hour}
                        onClick={() => setweekHoursOption(hour)}
                        className={`px-2 py-1 text-xs rounded-lg font-medium transition-colors duration-200 ${
                          weekHoursOption === hour
                            ? "bg-blue-100 border border-blue-500 text-blue-700"
                            : "border border-slate-200 text-slate-700 hover:bg-slate-50"
                        }`}
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        {hour}
                      </motion.button>
                    ))}
                  </div>
                )}
              </motion.div>
            </motion.div>
            {/* Tableau des Heures */}
            <motion.div
              className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden mb-8"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
            >
              <div className="px-6 py-4 border-b border-slate-200">
                <div className="flex items-center justify-between">
                  <h3 className="text-lg font-semibold text-slate-900">Saisie des Heures</h3>
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center space-x-2">
                      <div className="flex items-center space-x-1">
                        <div className="w-3 h-3 rounded-full bg-amber-100 border border-amber-300"></div>
                        <span className="text-xs text-slate-500">Heures de nuit</span>
                      </div>
                      <span className="text-slate-300">•</span>
                      <span className="text-xs text-slate-500">
                        {nightHoursOption === "included" ? "Incluses" : "Additionnelles"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-6">
                <div className="overflow-x-auto">
                  <div className="grid grid-cols-8 gap-4 min-w-max">
                    {/* En-tête */}
                    <div className="flex items-center justify-center">
                      <span className="text-sm font-medium text-slate-600">Type</span>
                    </div>
                    {weekDays.map((day) => (
                      <div key={`head-${day.key}`} className="text-center">
                        <p className="font-medium text-slate-800">{day.name}</p>
                        <p className="text-xs text-slate-500">{day.date}</p>
                      </div>
                    ))}

                    {/* Heures de jour */}
                    <div className="flex items-center justify-center">
                      <div className="flex items-center space-x-2">
                        <div className="w-8 h-8 rounded-full bg-amber-100 flex items-center justify-center">
                          <Sun className="w-4 h-4 text-amber-600" />
                        </div>
                        <span className="text-sm font-medium text-slate-700">Jour</span>
                      </div>
                    </div>
                    {weekDays.map((day, index) => (
                      <div key={`day-${day.key}`} className="flex justify-center">
                        {isPdfExporting ? (
                          <div className="w-20 h-12 text-center text-sm flex items-center justify-center text-slate-800 bg-slate-50 rounded-lg border">
                            {formatHours(timeSheet.hours[day.key]) || "-"}
                          </div>
                        ) : (
                          <motion.input
                            type="text"
                            disabled={isLocked && !modificationApproved}
                            value={formatHours(timeSheet.hours[day.key])}
                            onChange={(e) => {
                              const value = e.target.value.replace(",", ".");
                              handleHourChange(day.key, value);
                            }}
                            className="w-20 h-12 text-sm text-center border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                            whileFocus={{ scale: 1.05 }}
                            placeholder="0:00"
                          />
                        )}
                      </div>
                    ))}

                    {/* Heures de nuit */}
                    <div className="flex items-center justify-center">
                      <div className="flex items-center space-x-2">
                        <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
                          <Moon className="w-4 h-4 text-blue-600" />
                        </div>
                        <span className="text-sm font-medium text-slate-700">Nuit</span>
                      </div>
                    </div>
                    {weekDays.map((day, index) => (
                      <div key={`night-${day.key}`} className="flex justify-center">
                        {isPdfExporting ? (
                          <div className="w-20 h-12 text-center text-sm flex items-center justify-center text-slate-800 bg-slate-50 rounded-lg border">
                            {formatHours(timeSheet.nightHours[day.key]) || "-"}
                          </div>
                        ) : (
                          <motion.input
                            type="text"
                            disabled={isLocked && !modificationApproved}
                            value={formatHours(timeSheet.nightHours[day.key])}
                            onChange={(e) => {
                              const value = e.target.value.replace(",", ".");
                              handleNightHourChange(day.key, value);
                            }}
                            className="w-20 h-12 text-sm text-center border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                            whileFocus={{ scale: 1.05 }}
                            placeholder="0:00"
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Motifs d'absence */}
            <motion.div
              className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 mb-8"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 1.0 }}
            >
              <h3 className="text-lg font-semibold text-slate-900 mb-4">Motifs d'absence</h3>
              <div className="grid grid-cols-8 gap-4">
                <div className="flex items-center justify-center">
                  <span className="text-sm font-medium text-slate-600">Absence</span>
                </div>
                {weekDays.map((day) => (
                  <div key={`absence-${day.key}`} className="flex justify-center">
                    {isPdfExporting ? (
                      <div className="w-20 h-12 px-2 py-1 text-sm text-slate-800 text-center flex items-center justify-center bg-slate-50 rounded-lg border">
                        {timeSheet.absences[day.key] || "-"}
                      </div>
                    ) : (
                      <motion.select
                        value={timeSheet.absences[day.key]}
                        disabled={isLocked && !modificationApproved}
                        onChange={(e) => updateAbsence(day.key, e.target.value)}
                        className="w-20 h-12 text-xs text-center border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                        whileFocus={{ scale: 1.05 }}
                      >
                        <option value="">-</option>
                        <option value="AI">AI</option>
                        <option value="AJ">AJ</option>
                        <option value="ATR">ATR</option>
                        <option value="AT">AT</option>
                        <option value="CP">CP</option>
                        <option value="M">M</option>
                        <option value="R">R</option>
                        <option value="RTT">RTT</option>
                        <option value="AUTRE">Autre</option>
                      </motion.select>
                    )}
                  </div>
                ))}
              </div>
            </motion.div>

            {/* Résumé de la semaine */}
            <motion.div
              className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-xl shadow-sm border border-blue-200 p-6 mb-8"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 1.2 }}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="p-3 bg-blue-600 rounded-xl">
                    <Clock className="w-8 h-8 text-white" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-blue-900">Total de la semaine</h3>
                    <p className="text-blue-700">Récapitulatif des heures travaillées</p>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-4xl font-bold text-blue-900">
                    {calculateTotalHours().toFixed(1)}h
                  </div>
                  {calculateOvertimeHours() > 0 && (
                    <div className="text-sm text-blue-700 font-medium">
                      +{calculateOvertimeHours().toFixed(1)}h supplémentaires
                    </div>
                  )}
                </div>
              </div>
            </motion.div>
            {/* Section heures diverses */}
            <motion.div
              className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 mb-8"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 1.4 }}
            >
              <div className="flex items-center space-x-3 mb-6">
                <div className="p-3 bg-green-100 rounded-xl">
                  <DollarSign className="w-6 h-6 text-green-600" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-slate-900">Heures diverses</h3>
                  <p className="text-sm text-slate-600">Ces heures seront facturées au même taux que les heures normales</p>
                </div>
              </div>

              {!isPdfExporting && (
                <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">
                  {/* Type d'heure */}
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Type d'heure</label>
                    <Select
                      value={selectedHeure}
                      disabled={isLocked && !modificationApproved}
                      onChange={(value) => { setSelectedHeure(value); }}
                      options={heureOptions}
                      placeholder="Sélectionner un type"
                      className="text-sm"
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderColor: '#e2e8f0',
                          borderRadius: '0.75rem',
                          minHeight: '48px',
                          '&:hover': { borderColor: '#3b82f6' },
                          '&:focus': { borderColor: '#3b82f6', boxShadow: '0 0 0 2px rgba(59, 130, 246, 0.1)' }
                        })
                      }}
                    />
                  </div>

                  {/* Quantité */}
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Quantité</label>
                    <motion.input
                      type="number"
                      disabled={isLocked && !modificationApproved}
                      min="0"
                      step="0.1"
                      value={quantiteHeure}
                      onChange={(e) => setQuantiteHeure(e.target.value)}
                      className="w-full h-12 px-4 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                      placeholder="0.0"
                      whileFocus={{ scale: 1.02 }}
                    />
                  </div>

                  {/* Bouton Ajouter/Modifier */}
                  <div className="flex items-end">
                    {editingHeureId ? (
                      <motion.button
                        onClick={handleUpdateHeure}
                        className="w-full h-12 px-4 bg-green-600 text-white rounded-xl hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 font-medium transition-colors duration-200 flex items-center justify-center space-x-2"
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        <Edit3 className="w-4 h-4" />
                        <span>Enregistrer</span>
                      </motion.button>
                    ) : (
                      <motion.button
                        onClick={handleAddHeure}
                        className="w-full h-12 px-4 bg-blue-600 text-white rounded-xl hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 font-medium transition-colors duration-200 flex items-center justify-center space-x-2"
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        <Plus className="w-4 h-4" />
                        <span>Ajouter</span>
                      </motion.button>
                    )}
                  </div>
                </div>
              )}

              {/* Liste des heures ajoutées */}
              <div className="space-y-3 mt-6">
                <AnimatePresence>
                  {heures.map((row, index) => (
                    <motion.div
                      key={row.id}
                      className="flex items-center justify-between p-4 bg-slate-50 rounded-xl border border-slate-200"
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: 20 }}
                      transition={{ duration: 0.3, delay: index * 0.1 }}
                      whileHover={{ y: -2 }}
                    >
                      <div className="flex items-center space-x-3">
                        <div className="w-2 h-2 rounded-full bg-green-500"></div>
                        <div>
                          <span className="font-medium text-slate-800">{row.type}</span>
                          <span className="ml-2 text-slate-600">({row.quantite}h)</span>
                        </div>
                      </div>
                      {!isPdfExporting && (
                        <div className="flex space-x-2">
                          <motion.button
                            onClick={() => startEditHeure(row)}
                            className="p-2 text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-lg transition-colors duration-200"
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                          >
                            <Pencil className="h-4 w-4" />
                          </motion.button>
                          <motion.button
                            onClick={() => handleDeleteHeure(row.id)}
                            className="p-2 text-red-600 hover:text-red-800 hover:bg-red-50 rounded-lg transition-colors duration-200"
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                          >
                            <Trash2 className="h-4 w-4" />
                          </motion.button>
                        </div>
                      )}
                    </motion.div>
                  ))}
                </AnimatePresence>
                {heures.length === 0 && (
                  <div className="text-center py-8">
                    <div className="text-slate-400 mb-2">
                      <FileText className="w-12 h-12 mx-auto" />
                    </div>
                    <p className="text-slate-500">Aucune heure diverse ajoutée</p>
                  </div>
                )}
              </div>
            </motion.div>
            {/* Section primes */}
            <motion.div
              className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 mb-8"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 1.6 }}
            >
              <div className="flex items-center space-x-3 mb-6">
                <div className="p-3 bg-purple-100 rounded-xl">
                  <Gift className="w-6 h-6 text-purple-600" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-slate-900">Primes</h3>
                  <p className="text-sm text-slate-600">Ces primes sont assujetties aux charges sociales</p>
                </div>
              </div>

              {!isPdfExporting && (
                <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">
                  {/* Type de prime */}
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Type de prime</label>
                    <Select
                      value={selectedPrime}
                      disabled={isLocked && !modificationApproved}
                      onChange={(value) => { setSelectedPrime(value); }}
                      options={primeOptions}
                      placeholder="Sélectionner une prime"
                      className="text-sm"
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderColor: '#e2e8f0',
                          borderRadius: '0.75rem',
                          minHeight: '48px',
                          '&:hover': { borderColor: '#3b82f6' },
                          '&:focus': { borderColor: '#3b82f6', boxShadow: '0 0 0 2px rgba(59, 130, 246, 0.1)' }
                        })
                      }}
                    />
                  </div>

                  {/* Quantité */}
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Quantité</label>
                    <motion.input
                      type="number"
                      disabled={isLocked && !modificationApproved}
                      min="0"
                      value={quantitePrime}
                      onChange={(e) => setQuantitePrime(e.target.value)}
                      className="w-full h-12 px-4 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                      placeholder="0.00"
                      whileFocus={{ scale: 1.02 }}
                    />
                  </div>

                  {/* Montant Prime */}
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Montant (€)</label>
                    <motion.input
                      type="number"
                      disabled={isLocked && !modificationApproved}
                      min="0"
                      step="0.01"
                      value={montantPrime}
                      onChange={(e) => setMontantPrime(e.target.value)}
                      className="w-full h-12 px-4 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                      placeholder="0.00"
                      whileFocus={{ scale: 1.02 }}
                    />
                  </div>

                  {/* Bouton Ajouter/Modifier */}
                  <div className="flex items-end">
                    {editingPrimeId ? (
                      <motion.button
                        onClick={handleUpdatePrime}
                        className="w-full h-12 px-4 bg-green-600 text-white rounded-xl hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 font-medium transition-colors duration-200 flex items-center justify-center space-x-2"
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        <Edit3 className="w-4 h-4" />
                        <span>Enregistrer</span>
                      </motion.button>
                    ) : (
                      <motion.button
                        onClick={handleAddPrime}
                        className="w-full h-12 px-4 bg-blue-600 text-white rounded-xl hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 font-medium transition-colors duration-200 flex items-center justify-center space-x-2"
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        <Plus className="w-4 h-4" />
                        <span>Ajouter</span>
                      </motion.button>
                    )}
                  </div>
                </div>
              )}

              {/* Liste des primes ajoutées */}
              <div className="space-y-3 mt-6">
                <AnimatePresence>
                  {primes.map((row, index) => (
                    <motion.div
                      key={row.id}
                      className="flex items-center justify-between p-4 bg-slate-50 rounded-xl border border-slate-200"
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: 20 }}
                      transition={{ duration: 0.3, delay: index * 0.1 }}
                      whileHover={{ y: -2 }}
                    >
                      <div className="flex items-center space-x-3">
                        <div className="w-2 h-2 rounded-full bg-purple-500"></div>
                        <div>
                          <span className="font-medium text-slate-800">{row.type}</span>
                          <span className="ml-2 text-slate-600">({row.quantite} × {row.montant.toFixed(2)}€ = {(row.quantite * row.montant).toFixed(2)}€)</span>
                        </div>
                      </div>
                      {!isPdfExporting && (
                        <div className="flex space-x-2">
                          <motion.button
                            onClick={() => startEditPrime(row)}
                            className="p-2 text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-lg transition-colors duration-200"
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                          >
                            <Pencil className="h-4 w-4" />
                          </motion.button>
                          <motion.button
                            onClick={() => handleDeletePrime(row.id)}
                            className="p-2 text-red-600 hover:text-red-800 hover:bg-red-50 rounded-lg transition-colors duration-200"
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                          >
                            <Trash2 className="h-4 w-4" />
                          </motion.button>
                        </div>
                      )}
                    </motion.div>
                  ))}
                </AnimatePresence>
                {primes.length === 0 && (
                  <div className="text-center py-8">
                    <div className="text-slate-400 mb-2">
                      <Gift className="w-12 h-12 mx-auto" />
                    </div>
                    <p className="text-slate-500">Aucune prime ajoutée</p>
                  </div>
                )}
              </div>
            </motion.div>

            {/* Section commentaires */}
            <motion.div
              className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 1.8 }}
            >
              <motion.div
                className="bg-white rounded-xl shadow-sm border border-slate-200 p-6"
                whileHover={{ y: -2 }}
              >
                <div className="flex items-center space-x-3 mb-4">
                  <div className="p-2 bg-blue-100 rounded-lg">
                    <MessageSquare className="w-5 h-5 text-blue-600" />
                  </div>
                  <h3 className="text-lg font-semibold text-slate-900">Commentaire du client</h3>
                </div>
                {isPdfExporting ? (
                  <p className="text-sm text-slate-800 whitespace-pre-wrap">{clientComment}</p>
                ) : (
                  <motion.textarea
                    className="w-full h-32 px-4 py-3 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none transition-all duration-200"
                    value={clientComment}
                    disabled={isLocked && !modificationApproved}
                    onChange={(e) => setClientComment(e.target.value)}
                    placeholder="Saisissez un commentaire..."
                    whileFocus={{ scale: 1.02 }}
                  />
                )}
              </motion.div>

              <motion.div
                className="bg-white rounded-xl shadow-sm border border-slate-200 p-6"
                whileHover={{ y: -2 }}
              >
                <div className="flex items-center space-x-3 mb-4">
                  <div className="p-2 bg-green-100 rounded-lg">
                    <User className="w-5 h-5 text-green-600" />
                  </div>
                  <h3 className="text-lg font-semibold text-slate-900">Commentaire de l'intérimaire</h3>
                </div>
                {isPdfExporting ? (
                  <p className="text-sm text-slate-800 whitespace-pre-wrap">...</p>
                ) : (
                  <motion.textarea
                    className="w-full h-32 px-4 py-3 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none transition-all duration-200"
                    placeholder="Pour information, voici le commentaire de l'intérimaire"
                    disabled={isLocked && !modificationApproved}
                    whileFocus={{ scale: 1.02 }}
                  />
                )}
              </motion.div>
            </motion.div>

            {/* Évaluation de l'intérimaire */}
            <motion.div
              className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 mb-8"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 2.0 }}
            >
              <div className="flex items-center space-x-3 mb-6">
                <div className="p-3 bg-amber-100 rounded-xl">
                  <Star className="w-6 h-6 text-amber-600" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-slate-900">Évaluation de l'intérimaire</h3>
                  <p className="text-sm text-slate-600">Notez la performance du collaborateur</p>
                </div>
              </div>

              <div className="mb-6">
                <label className="block text-sm font-medium text-slate-700 mb-3">Note du client</label>
                <div className="flex space-x-2">
                  {[1, 2, 3, 4, 5].map((rating) => (
                    <motion.button
                      key={rating}
                      onClick={() => setClientRating(rating)}
                      className={`w-12 h-12 rounded-full flex items-center justify-center border-2 transition-all duration-200 ${
                        clientRating >= rating
                          ? 'bg-amber-100 border-amber-400 text-amber-600'
                          : 'border-slate-300 text-slate-400 hover:border-amber-300'
                      }`}
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.9 }}
                    >
                      <Star className={`h-6 w-6 ${clientRating >= rating ? 'fill-current' : ''}`} />
                    </motion.button>
                  ))}
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-slate-700 mb-3">Commentaire sur l'évaluation</label>
                {isPdfExporting ? (
                  <p className="text-sm text-slate-800 whitespace-pre-wrap">{clientRatingComment}</p>
                ) : (
                  <motion.textarea
                    className="w-full h-32 px-4 py-3 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none transition-all duration-200"
                    value={clientRatingComment}
                    disabled={isLocked && !modificationApproved}
                    onChange={(e) => setClientRatingComment(e.target.value)}
                    placeholder="Points forts, points à améliorer, conseils..."
                    whileFocus={{ scale: 1.02 }}
                  />
                )}
              </div>
            </motion.div>

            {/* Information de saisie */}
            <motion.div
              className="bg-slate-100 rounded-xl border border-slate-200 p-6 mb-8"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 2.2 }}
            >
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm text-slate-600">
                <div>
                  <span className="font-medium text-slate-700">Saisi par :</span> Dupont Jean (Agent administratif)
                </div>
                <div>
                  <span className="font-medium text-slate-700">Date d'envoi à l'agence :</span> 09/04/2025 à 14:30
                </div>
                <div>
                  <span className="font-medium text-slate-700">Date de validation par l'agence :</span> 09/04/2025 à 14:30
                </div>
              </div>
            </motion.div>

            {/* Boutons d'action */}
            {!isPdfExporting && (
              <motion.div
                className="flex flex-wrap gap-4 justify-end"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 2.0 }}
              >
                <motion.button
                  onClick={handleSave}
                  disabled={isLocked || isSaving}
                  className={`px-6 py-3 rounded-xl font-medium transition-all duration-200 flex items-center space-x-2 ${
                    isLocked || isSaving
                      ? "bg-slate-300 text-slate-500 cursor-not-allowed"
                      : "bg-red-600 hover:bg-red-700 text-white shadow-lg hover:shadow-xl"
                  }`}
                  whileHover={!isLocked && !isSaving ? { scale: 1.02, y: -2 } : {}}
                  whileTap={!isLocked && !isSaving ? { scale: 0.98 } : {}}
                >
                  <Save className="w-5 h-5" />
                  <span>{isSaving ? "Enregistrement..." : "Enregistrer"}</span>
                </motion.button>

                <motion.button
                  onClick={sendToAgency}
                  className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-medium transition-all duration-200 shadow-lg hover:shadow-xl flex items-center space-x-2"
                  whileHover={{ scale: 1.02, y: -2 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <Send className="w-5 h-5" />
                  <span>Envoyer vers l'agence</span>
                </motion.button>

                <motion.button
                  onClick={submitTimeSheet}
                  disabled={isSubmitting}
                  className={`px-6 py-3 rounded-xl font-medium transition-all duration-200 shadow-lg hover:shadow-xl flex items-center space-x-2 ${
                    isSubmitting
                      ? "bg-slate-300 text-slate-500 cursor-not-allowed"
                      : "bg-green-600 hover:bg-green-700 text-white"
                  }`}
                  whileHover={!isSubmitting ? { scale: 1.02, y: -2 } : {}}
                  whileTap={!isSubmitting ? { scale: 0.98 } : {}}
                >
                  <FileText className="w-5 h-5" />
                  <span>{isSubmitting ? "Envoi en cours..." : "Envoyer vers Tempo"}</span>
                </motion.button>

                <motion.button
                  onClick={downloadTimeSheet}
                  className="px-6 py-3 bg-orange-500 hover:bg-orange-600 text-white rounded-xl font-medium transition-all duration-200 shadow-lg hover:shadow-xl flex items-center space-x-2"
                  whileHover={{ scale: 1.02, y: -2 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <Download className="w-5 h-5" />
                  <span>Télécharger PDF</span>
                </motion.button>

                <motion.button
                  onClick={handleModificationRequest}
                  disabled={!isLocked || modificationRequested}
                  className={`px-6 py-3 rounded-xl font-medium transition-all duration-200 flex items-center space-x-2 ${
                    (!isLocked || modificationRequested)
                      ? "bg-slate-300 text-slate-500 cursor-not-allowed"
                      : "bg-slate-600 hover:bg-slate-700 text-white shadow-lg hover:shadow-xl"
                  }`}
                  whileHover={(!isLocked && !modificationRequested) ? { scale: 1.02, y: -2 } : {}}
                  whileTap={(!isLocked && !modificationRequested) ? { scale: 0.98 } : {}}
                >
                  <AlertCircle className="w-5 h-5" />
                  <span>{modificationRequested ? "Demande envoyée" : "Demande de modification"}</span>
                </motion.button>
              </motion.div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default RelevesHeures;